// Common JSON structure for Indicators data
export interface IndicatorCardData {
  icon: string
  iconColor: 'green' | 'blue' | 'purple'
  title: string
  value: string | number
  description: string
}

export interface IndicatorCategoryData {
  title: string
  cards: IndicatorCardData[]
  filters?: {
    options: string[]
    active: string
    onChange: (filter: string) => void
  }
}

export interface IndicatorsDataStructure {
  nursing: IndicatorCategoryData
  doctors: IndicatorCategoryData
  psychologists: IndicatorCategoryData
  aps: IndicatorCategoryData
}

// Helper function to create indicator card data
export const createIndicatorCard = (
  icon: string,
  iconColor: 'green' | 'blue' | 'purple',
  title: string,
  value: string | number,
  description: string
): IndicatorCardData => {
  
  return {
    icon,
    iconColor,
    title,
    value,
    description
  }
}

// Helper function to create category data
export const createCategoryData = (
  title: string,
  cards: IndicatorCardData[],
  filters?: {
    options: string[]
    active: string
    onChange: (filter: string) => void
  }
): IndicatorCategoryData => ({
  title,
  cards,
  filters
})

// Static JSON data for Indicators
export const staticIndicatorsData: IndicatorsDataStructure = {
  nursing: {
    title: 'INDICADORES DE ENFERMAGEM',
    cards: [
      createIndicatorCard('fas fa-circle', 'green', 'On-line', 15, 'profissionais'),
      createIndicatorCard('fas fa-circle', 'blue', 'Em atendimento', 15, 'profissionais'),
      createIndicatorCard('fa-solid fa-check', 'purple', 'Taxa de sucesso', '95%', 'atendimentos completos'),
      createIndicatorCard('fas fa-users', 'purple', 'Pacientes atendidos', 30, 'Pacientes'),
      createIndicatorCard('fas fa-video', 'green', 'Tempo médio de atendimento', '09:25', 'minutos'),
      createIndicatorCard('fas fa-clock', 'purple', 'Tempo médio de espera', '03:42', 'minutos')
    ]
  },
  doctors: {
    title: 'INDICADORES DE MÉDICOS',
    cards: [
      createIndicatorCard('fas fa-circle', 'green', 'On-line', 15, 'clínicos'),
      createIndicatorCard('fas fa-circle', 'blue', 'Em atendimento', 9, 'clínicos'),
      createIndicatorCard('fas fa-check', 'purple', 'Taxa de sucesso', '95%', 'atendimentos completos'),
      createIndicatorCard('fas fa-users', 'purple', 'Pacientes atendidos', 30, 'Pacientes'),
      createIndicatorCard('fas fa-video', 'green', 'Tempo médio de atendimento', '09:25', 'minutos'),
      createIndicatorCard('fas fa-clock', 'purple', 'Tempo médio de espera', '03:42', 'minutos')
    ],
    filters: {
      options: ['Todos', 'Clínicos', 'Pediatras'],
      active: 'Clínicos',
      onChange: () => {} // Will be set by component
    }
  },
  psychologists: {
    title: 'INDICADORES DE PSICÓLOGOS',
    cards: [
      createIndicatorCard('fas fa-circle', 'green', 'On-line', 15, 'profissionais'),
      createIndicatorCard('fas fa-circle', 'blue', 'Em atendimento', 9, 'profissionais'),
      createIndicatorCard('fas fa-check', 'purple', 'Taxa de sucesso', '95%', 'atendimentos completos'),
      createIndicatorCard('fas fa-users', 'purple', 'Pacientes atendidos', 30, 'Pacientes'),
      createIndicatorCard('fas fa-video', 'green', 'Tempo médio de atendimento', '09:25', 'minutos'),
      createIndicatorCard('fas fa-clock', 'purple', 'Tempo médio de espera', '03:42', 'minutos')
    ]
  },
  aps: {
    title: 'INDICADORES DE ACOLHIMENTO APS',
    cards: [
      createIndicatorCard('fas fa-circle', 'green', 'On-line', 15, 'profissionais'),
      createIndicatorCard('fas fa-circle', 'blue', 'Em atendimento', 9, 'profissionais'),
      createIndicatorCard('fas fa-check', 'purple', 'Taxa de sucesso', '95%', 'atendimentos completos'),
      createIndicatorCard('fas fa-users', 'purple', 'Pacientes atendidos', 30, 'Pacientes'),
      createIndicatorCard('fas fa-video', 'green', 'Tempo médio de atendimento', '09:25', 'minutos'),
      createIndicatorCard('fas fa-clock', 'purple', 'Tempo médio de espera', '03:42', 'minutos')
    ]
  }
}

